import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "./sentry";
import * as Sentry from "@sentry/react";
import { BrandingProvider } from "./providers/BrandingProvider.tsx";
import { analytics } from "./analytics/analytics";

// eslint-disable-next-line react-refresh/only-export-components
const CrashFallback = () => (
  <div className="flex h-screen flex-col items-center justify-center gap-4 px-6 text-center">
    <h1 className="text-2xl font-semibold">Something went wrong</h1>
    <p className="text-muted-foreground">
      We&apos;ve logged the error and are looking into it. Try refreshing the page.
    </p>
    <button
      className="rounded-md bg-primary px-4 py-2 text-primary-foreground"
      onClick={() => window.location.reload()}
    >
      Reload
    </button>
  </div>
);

// Initialize analytics (safe no-op when the PostHog key is absent)
try {
  const POSTHOG_KEY = import.meta.env.VITE_POSTHOG_KEY;
  const POSTHOG_HOST = import.meta.env.VITE_POSTHOG_HOST;

  analytics.init(POSTHOG_KEY, { posthogHost: POSTHOG_HOST });

  const appEnv = import.meta.env.VITE_APP_ENV || import.meta.env.MODE || "development";
  const appVersion = import.meta.env.VITE_APP_VERSION || "unknown";
  analytics.setContext({ env: String(appEnv), appVersion: String(appVersion) });
} catch {}

createRoot(document.getElementById("root")!).render(
  <Sentry.ErrorBoundary fallback={<CrashFallback />}>
    <BrandingProvider>
      <App />
    </BrandingProvider>
  </Sentry.ErrorBoundary>
);
